import { Stack, Tooltip, Box } from '@mui/material'
import React from 'react'

interface StartingStatusIconsProps {
  starting?: boolean;
  confirmedLineup?: boolean;
  injuryStatus?: string;
}

const StartingStatusIcons = ({ starting, confirmedLineup, injuryStatus }: StartingStatusIconsProps) => {
  const getInjuryLabel = (status: string | undefined) => {
    switch (status?.toLowerCase()) {
      case 'questionable':
        return 'Q';
      case 'probable':
        return 'P';
      case 'doubtful':
        return 'D';
      case 'out':
        return 'O';
      case 'gleague':
        return 'G';
      default:
        return null;
    }
  };

  const getInjuryTooltip = (status: string | undefined) => {
    switch (status?.toLowerCase()) {
      case 'questionable':
        return 'Questionable';
      case 'probable':
        return 'Probable';
      case 'doubtful':
        return 'Doubtful';
      case 'out':
        return 'Out';
      case 'gleague':
        return 'G-League';
      default:
        return '';
    }
  };

  const getInjuryColor = (status: string | undefined) => {
    switch (status?.toLowerCase()) {
      case 'probable':
        return '#EED202'; // yellow
      case 'questionable':
        return '#FF8C00'; // orange
      case 'doubtful':
      case 'out':
      case 'gleague':
        return '#FF4444'; // red
      default:
        return '#FF4444';
    }
  };

  const injuryLabel = getInjuryLabel(injuryStatus);
  const injuryTooltip = getInjuryTooltip(injuryStatus);
  const injuryColor = getInjuryColor(injuryStatus);

  return (
    <Stack direction='row' alignItems='center' spacing={0.5}>
      {/* Starting indicator */}
      {starting === true && (
        <Tooltip title={confirmedLineup ? 'Starting (Confirmed)' : 'Starting (Projected)'} arrow>
          <Stack
            direction='row'
            alignItems='center'
            justifyContent='center'
            bgcolor={confirmedLineup ? 'rgba(0, 181, 83, .6)' : '#A90'}
            borderRadius='2px'
            height='18px'
            width='18px'
            sx={{ fontWeight: 700, fontSize: '11px' }}
          >
            S
          </Stack>
        </Tooltip>
      )}

      {/* Injury indicator */}
      {injuryLabel && (
        <Tooltip title={injuryTooltip} arrow>
          <Box
            sx={{
              fontWeight: 700,
              fontSize: '12px',
              color: injuryColor,
              lineHeight: 1
            }}
          >
            {injuryLabel}
          </Box>
        </Tooltip>
      )}
    </Stack>
  )
}

export default StartingStatusIcons
